import React, { useMemo } from 'react';
import styles from './MarketBody.module.scss';
import { useSelector } from 'react-redux';
import MarketGroups from './MarketGroups/MarketGroups';
import MarketTemplates from './MarketTemplates/MarketTemplates';
import { LANGUAGES } from '../../../constants/defaultValues';

const MarketBody = ({ markets, event }) => {
    const { locale } = useSelector(state => state.settings);
    const leagues = useSelector(state => state.sportEvents.filters.leagues) || [];

    const tournamentName = useMemo(() => {
        const league = leagues.find(league => league.id === event.seasonRefId);
        return league?.names[locale] || league?.names[LANGUAGES.eng];
    }, [leagues, event]);

    return (
        <div className={styles.marketsBody}>
            <MarketGroups markets={markets} />
            <MarketTemplates
                markets={markets}
                teams={event.teams}
                tournamentName={tournamentName}
                playerNames={event.playerNames}
            />
        </div>
    );
};

export default MarketBody;
